import { useEffect, useState } from "react";
import Step1BookingInfo from "./steps/Step1BookingInfo";
import Step2Financial from "./steps/Step2Financial";
import { getAllPromoters } from "../../api/promotersApi";
import { getAllArtists } from "../../api/artistApi";
import { getAllCompanies } from "../../api/companiesApi";
import { createBookings } from "../../api/bookingsApi";
import Step3FinalReview from "./steps/Step3FinalReview";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../components/pageLoader";
import ToastContainer from "../../components/toastContainer";
import Toast from "../../components/toast";

const BookingCreatePage = () => {
  const [step, setStep] = useState(1);

  const [artists, setArtists] = useState([]);
  const [promoters, setPromoters] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const navigate = useNavigate();

  const [form, setForm] = useState({
    promoter: "",
    artist: "",
    artist_fee_company: "",
    booking_fee_company: "",
    booking_date: "",
    contract_no: "",

    currency: "",
    artist_fee: "",
    booking_fee: "",

    installments: [],
    other_fees: [],
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const data_promoter = await getAllPromoters();
      const list_promoter = Array.isArray(data_promoter)
        ? data_promoter
        : data_promoter.results || [];
      setPromoters(list_promoter);

      const data_artists = await getAllArtists();
      const list_artists = Array.isArray(data_artists)
        ? data_artists
        : data_artists.results || [];
      setArtists(list_artists);

      const data_companies = await getAllCompanies();
      const list_companies = Array.isArray(data_companies)
        ? data_companies
        : data_companies.results || [];
      setCompanies(list_companies);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    try {
      const payload = {
        promoter: form.promoter,
        artist: form.artist,
        artist_fee_company: form.artist_fee_company,
        booking_fee_company: form.booking_fee_company,
        date: form.booking_date,

        contract_no: form.contract_no,

        currency: form.currency,
        artist_fee: Number(form.artist_fee),
        booking_fee: Number(form.booking_fee),

        payment_instalments: form.installments || [],
        other_fees: form.other_fees || [],
      };

      await createBookings(payload);

      navigate("/dashboard/bookings");
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to create booking",
      });
    }
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="space-y-10">
      {step === 1 && (
        <Step1BookingInfo
          form={form}
          setForm={setForm}
          promoters={promoters}
          artists={artists}
          companies={companies}
          onNext={() => setStep(2)}
        />
      )}

      {step === 2 && (
        <Step2Financial
          form={form}
          setForm={setForm}
          onNext={() => setStep(3)}
          onBack={() => setStep(1)}
        />
      )}

      {step === 3 && (
        <Step3FinalReview
          form={form}
          onBack={() => setStep(2)}
          onSubmit={handleSubmit}
        />
      )}

      <ToastContainer>
        {toast && (
          <div className="toast-enter">
            <Toast
              type={toast.type}
              message={toast.message}
              onClose={() => setToast(null)}
            />
          </div>
        )}
      </ToastContainer>
    </div>
  );
};

export default BookingCreatePage;
